import type * as React from 'react'

export function CircleAlertIcon({
	size = 24,
	color = 'currentColor',
	strokeWidth = 2,
	className,
	...props
}: React.SVGProps<SVGSVGElement> & {
	size?: number
	color?: string
	strokeWidth?: number
}) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
			className={className}
			aria-label="Alert icon"
			role="img"
			{...props}
		>
			<circle cx="12" cy="12" r="10" />
			<path d="M12 8v4m0 4h.01" />
		</svg>
	)
}
